<template>
  <div>
    <GlobalTable
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="false"
      :enableAddButton="false"
      :redirectDetail="false"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CForm>
          <CRow>
            <CCol sm="3">
              <CInput
                label="District Name"
                invalid-feedback="District name should be filled"
                required
                v-model="$v.districtForm.name.$model"
                :is-valid="!$v.districtForm.name.$invalid"
              />
            </CCol>
            <CCol sm="3">
              <div class="form-group">
                <label for="regency">Regency</label>
                <model-select
                  class="form-control"
                  id="regency"
                  :options="regenciesList"
                  v-model="$v.districtForm.regencies_id.$model"
                  :isError="$v.districtForm.regencies_id.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.districtForm.regencies_id.$invalid"
                  class="invalid-feedback-custom"
                >Regency should be filled.</div>
              </div>
            </CCol>
            <CCol sm="3">
              <CInput
                label="District Code"
                invalid-feedback="District code should be filled"
                required
                v-model="$v.districtForm.district_code.$model"
                :is-valid="!$v.districtForm.district_code.$invalid"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="12">
              <label for="nik">Description</label>
              <quill-editor style="height: 200px; margin-bottom:70px;"
                :content="content"
                :options="editorOption"
                v-model="$v.districtForm.description.$model"
                @change="onEditorChange($event)">
              </quill-editor>
              <div v-if="$v.districtForm.description.$invalid" class="invalid-feedback-custom">
                Description harus di isi.
              </div>
              <!-- <CTextarea
                rows="4"
                label="Description"
                invalid-feedback="Description should be filled"
                required
                v-model="$v.productCategoryForm.description.$model"
                :is-valid="!$v.productCategoryForm.description.$invalid"
              /> -->
            </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.districtForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import Loading from "../../../templates/Loading";

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'

export default {
  name: "District",
  components: { GlobalTable, Loading, quillEditor },
  data() {
    return {
      title: "District",
      fields: [
        { key: "name", label: "Nama Kecamatan/Kelurahan", sorter: true },
        { key: "district_code", label: "Kode Kecamatan/Keluarahan", sorter: true },
        { key: "description", label: "Description", sorter: true },
        // { key: "action", _classes: "text-center action" },
      ],
      items: [],
      districtForm: tableInterfaces.district,
      isLoading: false,
      addButton: false,
      isEdit: false,
      regenciesList:[],
       options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
      content: '',editorOption: {},	// data quill
    };
  },
  validations: {
    districtForm: {
      name: { required },
      description: {},
      district_code: {required},
      regencies_id:{required},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getDistrict();
      this.getProvinceList();
    },
    getDistrict: function () {
      this.isLoading = true;
      this.axios
        .get("console/master/district/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
     getProvinceList: function(){
      this.axios.get("console/dropdown/district/regencies").then((response) => {
        this.regenciesList = response.data.data;
      });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.districtForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.district) {
        tableInterfaces.district[i] = null;
      }
      this.districtForm = tableInterfaces.district;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/district/edit", this.districtForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/master/district/add", this.districtForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      }
    },
  },
  onEditorChange({ quill, html, text }) {
    this.content = html
    this.districtForm.description = html
  },
  mounted() {
    this.init();
  },
};
</script>
